export const SMARTPHONE_CATEGORY_ID = 2
